// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import caculateWidthBy10FontSize from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/caculateFontSize.js'
import {
  getMaxValue,
  getMaxLengthValue,
} from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getAdaptiveBarWidthByCount,
  BarSelectedBorderBuilder,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'
import { isEmpty } from 'lodash'

export const SERVICE_DURATION_LEGEND_ITEMS = t => [
  { name: t('Gattaran_opt_xawD_vBtI' /** 日均在线时长 */), type: 'bar', color: '#0D86FF' },
  {
    name: t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */),
    type: 'line',
    color: '#0c0c0d',
  },
  {
    name: t('FoodB_requirement_aAaC_nmQK' /** 高峰在线时长 */),
    type: 'bar',
    color: '#85C2FF',
  },
  {
    name: t('FoodB_Side_YfKV_vTcN' /** 高峰时段在线率 */),
    type: 'line',
    color: '#0c0c0d',
    dashType: true,
  },
]

export const SERVICE_TIMEOUT_LEGEND_ITEMS = t => [
  { name: t('FoodB_requirement_puhp_VPIQ' /** 出餐超时订单数 */), type: 'bar', color: '#0D86FF' },
  {
    name: t('FoodB_requirement_uBiP_YocR' /** 出餐超时率 */),
    type: 'line',
    color: '#0C0C0D',
  },
]

export const SERVICE_QUESTION_LEGEND_ITEMS = t => [
  { name: t('FoodC_revision_Less_meal_pHwq' /** 少餐反馈 */), type: 'bar', color: '#086ACC' },
  { name: t('FoodC_improve__ovBF' /** 份量少 */), type: 'bar', color: '#369AFF' },
  { name: t('FoodC_improve__ByLg' /** 与预期不符 */), type: 'bar', color: '#85C2FF' },
  {
    name: t('CS_Aftersale_Wrong_meal_gNCe' /** 餐品问题反馈 */),
    type: 'bar',
    color: '#D6EBFF',
  },
  { name: t('Gattaran_opt2_egxV_xfoW' /** 问题订单率 */), type: 'line', color: '#0C0C0D' },
]

const durationCfg = getEchartHeightAndBottomByLocale('serviceDuration')
const serviceDurationBottom = durationCfg.bottom
const serviceDurationBottomHor = durationCfg.bottomHor

const timeoutCfg = getEchartHeightAndBottomByLocale('serviceTimeout')
const serviceTimeoutBottom = timeoutCfg.bottom
const serviceTimeoutBottomHor = timeoutCfg.bottomHor

const cancelCfg = getEchartHeightAndBottomByLocale('serviceCancel')
const serviceCancelBottom = cancelCfg.bottom
const serviceCancelBottomHor = cancelCfg.bottomHor
const serviceCancelHeight = cancelCfg.height
const serviceCancelHeightHor = cancelCfg.heightHor

const questionCfg = getEchartHeightAndBottomByLocale('serviceQuestion')
const serviceQuestionBottom = questionCfg.bottom
const serviceQuestionBottomHor = questionCfg.bottomHor

// ------------------------------
// Legend / Grid 布局辅助（解决 legend 压到图表上的问题）
// 说明：ECharts 的 legend 不会自动“挤开” grid，需要我们为 legend 预留 bottom 空间。
// 这里使用“按容器宽度估算 legend 换行行数”的方式，动态增加 grid.bottom。
// 注意：目前 transformer 未传入容器真实宽度，因此使用经验值做估算；
// 若后续可拿到容器 clientWidth，建议将 width 作为参数传入以获得更精确的结果。
// ------------------------------

// legend 每一项的粗略布局参数（与 LegendBuilder 的默认样式保持一致的体验即可）
// const LEGEND_ICON_WIDTH = 10
// const LEGEND_ICON_GAP = 10
// const LEGEND_ITEM_GAP = 12
// const LEGEND_PADDING_LR = 16
// const LEGEND_LINE_HEIGHT = 20 // 每行 legend 的占用高度（包含上下间距）

/**
 * 获取图表容器宽度的“估算值”。
 * - 这里用于 legend 自动换行行数的估算，避免 legend 覆盖图表。
 * - 若后续能拿到真实容器宽度（例如 this.$el.clientWidth），应优先用真实宽度替代。
 */
// function getApproxChartWidth(direction) {
//   // 小屏竖屏通常更窄，给一个更保守的宽度
//   if (direction === 'vertical') return isNarrowViewport() ? 320 : 343
//   // 横屏/Pad 场景更宽
//   return isNarrowViewport() ? 568 : 667
// }

/**
 * 估算 legend 需要的行数（labels 会按宽度自动换行）。
 * @param {string[]} labels - legend 文案集合
 * @param {number} chartWidth - 容器宽度（可为估算值）
 */
// function calcLegendRows(labels = [], chartWidth) {
//   const available = Math.max(chartWidth - LEGEND_PADDING_LR * 2, 1)
//   let rows = 1
//   let rowWidth = 0

//   labels.forEach(text => {
//     // 使用项目内的宽度估算工具（fontSize 默认为 10，这里显式传入 12 更接近 legend 文案）
//     const textWidth = caculateWidthBy10FontSize(text)
//     const itemWidth = LEGEND_ICON_WIDTH + LEGEND_ICON_GAP + textWidth + LEGEND_ITEM_GAP
//     // 超过当前行可用宽度则换行
//     if (rowWidth + itemWidth > available) {
//       rows += 1
//       rowWidth = itemWidth
//     } else {
//       rowWidth += itemWidth
//     }
//   })

//   return rows
// }

// 图表高度是否需要动态补偿
// function isNarrowViewport(threshold = 430) {
//   return window.innerWidth <= threshold
// }

/**
 * 计算「取消原因」图表在小屏场景下建议额外增加的高度。
 * 背景：当 legend 换行较多时，虽然我们通过动态 grid.bottom 预留了 legend 空间，
 * 但整体 chartHeight 仍然固定，导致“绘图区”被压缩得过小（柱子/坐标轴/tooltip 显示不够）。
 * 因此在小屏下，按 legend 的换行行数，给取消原因图表额外增加一些高度。
 *
 * @param {object} chartData - 后台返回的 chartData
 * @param {'vertical'|'horizontal'} direction - 竖屏/横屏
 * @returns {number} 需要追加的高度（px）
 */
// function getCancelReasonExtraHeight(chartData = {}, direction) {
//   // 非小屏不额外加高，避免其它端出现大量空白
//   if (!isNarrowViewport()) return 0

//   // 仅在竖屏更容易“挤”，横屏一般宽度更大，可按需开启
//   if (direction !== 'vertical') return 0

//   // 与 parseCancelReasonChartsData 内保持一致：仅统计“有效展示”的原因
//   const reasonFields = [
//     'dishSoldOut',
//     'storeClosed',
//     'dishNotServeTooBusy',
//     'dishNotServeUnexpectedReason',
//     'cDutyCancel',
//     'riderNeverBeenStore',
//     'otherQuestion',
//     'noRiderInStore',
//     'menuNeedUpdate',
//     'orderInDangerArea',
//     'orderBeyondDeliveryRange',
//     'prankOrder',
//     'questionAboutActivitiesExpenses',
//     'orderMissedTimeout',
//     'selfDeliveryTimeout',
//     'otherBDutyCancelOrder',
//   ]

//   // labels 使用 i18n 的实际展示文案（pt-BR 文案更长，换行风险更大）
//   const fieldToLabel = {
//     dishSoldOut: vueI18n.t('FoodB_scenario_tTcW_glIK'),
//     storeClosed: vueI18n.t('FoodB_scenario_TNIB_LZav'),
//     dishNotServeTooBusy: vueI18n.t('FoodB_scenario_FkIm_wbyt'),
//     dishNotServeUnexpectedReason: vueI18n.t('FoodB_scenario_ShEY_kNaS'),
//     cDutyCancel: vueI18n.t('FoodB_scenario_HbKA_WhYt'),
//     riderNeverBeenStore: vueI18n.t('FoodB_scenario_cPkp_BcjZ'),
//     otherQuestion: vueI18n.t('FoodB_scenario_LpfM_MGER'),
//     noRiderInStore: vueI18n.t('FoodB_scenario_psNp_kSMI'),
//     menuNeedUpdate: vueI18n.t('FoodB_scenario_czrv_MZIJ'),
//     orderInDangerArea: vueI18n.t('FoodB_scenario_YcnE_hnLK'),
//     orderBeyondDeliveryRange: vueI18n.t('FoodB_scenario_iTKN_qRYT'),
//     prankOrder: vueI18n.t('FoodB_scenario_FmAJ_xFEY'),
//     questionAboutActivitiesExpenses: vueI18n.t('FoodB_scenario_Essn_oVjW'),
//     orderMissedTimeout: vueI18n.t('FoodB_scenario_tWmb_Krny'),
//     selfDeliveryTimeout: vueI18n.t('FoodB_scenario_UTGm_CSqz'),
//     otherBDutyCancelOrder: vueI18n.t('FoodB_scenario_PuLv_FhUL'),
//   }
//   const enabledLabels = reasonFields
//     .filter(field => {
//       const raw = chartData?.[field] || []
//       if (!raw || raw.length === 0) return false
//       return raw.some(item => {
//         const v = Number(item?.value ?? 0)
//         return !Number.isNaN(v) && v !== 0
//       })
//     })
//     .map(field => fieldToLabel[field])

//   if (!enabledLabels.length) return 0

//   const approxChartWidth = getApproxChartWidth(direction)
//   const legendRows = calcLegendRows(enabledLabels, approxChartWidth)
//   // legend 只有 4 行时不需要额外加高；每多 1 行，增加一行高度 + 少量缓冲
//   if (legendRows <= 4) return 0

//   return (legendRows - 4) * LEGEND_LINE_HEIGHT + 12
// }

export default function transformer(
  data = {},
  dateToWeek,
  key = 'service',
  direction,
  isFullIndicator = true, // 是否展示Service(服务版块)全部Tab
) {
  const verticalHeight = serviceCancelHeight
  const horizontalHeight = serviceCancelHeightHor
  const baseHeight = direction === 'vertical' ? verticalHeight : horizontalHeight
  // 动态高度：取消原因在小屏竖屏 + legend 多行时，固定高度会导致绘图区过小。
  // 这里将“Service 模块的整体 chartHeight”提升到能够覆盖最“挤”的那张图（取消原因）。
  // const cancelReasonExtraHeight = getCancelReasonExtraHeight(data.chartData, direction)
  const chartHeight = baseHeight

  const temp = isFullIndicator
    ? [
        parseDurationChartsData(data.chartData, dateToWeek, direction, chartHeight), // 营业时长
        parseCancelReasonChartsData(data.chartData, dateToWeek, direction, chartHeight), // 取消订单
        parseServiceChartsData(data.chartData, dateToWeek, direction, chartHeight), // 问题订单
        parseTimeoutChartsData(data.chartData, dateToWeek, direction, chartHeight), // 出餐超时
      ]
    : [
        parseCancelReasonChartsData(data.chartData, dateToWeek, direction, chartHeight), // 取消订单
        parseServiceChartsData(data.chartData, dateToWeek, direction, chartHeight), // 问题订单
        parseTimeoutChartsData(data.chartData, dateToWeek, direction, chartHeight), // 出餐超时
      ]
  const chartData = temp.filter(chart => {
    return chart.isShow
  })
  console.log(' service transformer chartData', temp)
  return {
    title: vueI18n.t('Gattaran_V1__hUDQ' /** 服务 */),
    ...data,
    chartData,
    chartHeight,
    chartkey: key,
  }
}

// 营业时长
function parseDurationChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  // console.log('parse: parseDurationChartsData', chartData)
  const {
    onlineDuration = [], // 日均在线时长
    onlineRatio = [], // 在线率
    peakOnlineDuration = [], // 高峰在线时长
    peakOnlineRatio = [], // 高峰在线率
  } = chartData || {}
  console.log(' 营业时长 chartData', chartData)
  const max = getMaxValue({ onlineDuration })
  const maxConnectivity = getMaxLengthValue({ onlineRatio })
  const xAxisData = onlineDuration.map(item => item.date)
  const barWidth = getAdaptiveBarWidthByCount(xAxisData.length)
  const left = max ? caculateWidthBy10FontSize(max) + 10 : 16
  const right =
    (maxConnectivity
      ? caculateWidthBy10FontSize(maxConnectivity + '%')
      : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    isShow: [onlineDuration, onlineRatio, peakOnlineDuration, peakOnlineRatio].some(
      i => !isEmpty(i),
    ),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceDurationBottom : serviceDurationBottomHor,
    },
    tooltip: ToolTipBuilder({
      dashedLineSeriesNames: [vueI18n.t('FoodB_Side_YfKV_vTcN' /** 高峰时段在线率 */)],
    }),
    legend: LegendBuilder(
      [
        vueI18n.t('Gattaran_opt_xawD_vBtI' /** 日均在线时长 */),
        {
          name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */),
          icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
        },
        vueI18n.t('FoodB_requirement_aAaC_nmQK' /** 高峰在线时长 */),
        {
          name: vueI18n.t('FoodB_Side_YfKV_vTcN' /** 高峰时段在线率 */),
          icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
        },
      ],
      { show: false },
    ),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('Gattaran_opt_JcLo_plhe' /** 在线时长 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */) + '%',
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('Gattaran_opt_xawD_vBtI' /** 日均在线时长 */),
        type: 'bar',
        barWidth,
        color: '#0D86FF',
        stack: 'test',
        data: onlineDuration.map(item => item.value),
        ...BarSelectedBorderBuilder({ barWidth }),
        emphasis: {
          itemStyle: {
            color: '#0D86FF',
          },
        },
      },
      {
        name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#0c0c0d',
        lineStyle: {
          width: 2,
        },
        emphasis: {
          itemStyle: {
            color: '#0c0c0d',
          },
        },
        data: onlineRatio.map(item => item.value),
      },
      {
        name: vueI18n.t('FoodB_requirement_aAaC_nmQK' /** 高峰在线时长 */),
        type: 'bar',
        barWidth,
        color: '#85C2FF',
        stack: 'test',
        data: peakOnlineDuration.map(item => item.value),
        ...BarSelectedBorderBuilder({ barWidth }),
        emphasis: {
          itemStyle: {
            color: '#85C2FF',
          },
        },
      },
      {
        name: vueI18n.t('FoodB_Side_YfKV_vTcN' /** 高峰时段在线率 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#0c0c0d',
        lineStyle: {
          width: 2,
          type: 'dashed',
        },
        emphasis: {
          itemStyle: {
            color: '#fff',
            borderColor: '#0c0c0d',
            borderWidth: 4,
          },
        },
        data: peakOnlineRatio.map(item => item.value),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
    legendItems: SERVICE_DURATION_LEGEND_ITEMS(vueI18n.t.bind(vueI18n)),
  }
}

// 出餐超时
function parseTimeoutChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  console.log('parse: parseTimeoutChartsData', chartData)
  // 出餐超时订单数、出餐超时率
  const { deliveryOrdersCntRadio = [], deliveryOrdersCntRate = [] } = chartData || {}
  const max = getMaxValue({ deliveryOrdersCntRadio })
  const maxConnectivity = getMaxLengthValue({ deliveryOrdersCntRate })
  const xAxisData = deliveryOrdersCntRadio.map(item => item.date)
  const barWidth = getAdaptiveBarWidthByCount(xAxisData.length)
  const left = max ? caculateWidthBy10FontSize(max) + 10 : 16
  const right =
    (maxConnectivity
      ? caculateWidthBy10FontSize(maxConnectivity + '%')
      : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    isShow: [deliveryOrdersCntRadio, deliveryOrdersCntRate].some(i => !isEmpty(i)),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceTimeoutBottom : serviceTimeoutBottomHor,
    },
    tooltip: ToolTipBuilder(),
    legend: LegendBuilder(
      [
        vueI18n.t('FoodB_requirement_puhp_VPIQ' /** 出餐超时订单数 */),
        {
          name: vueI18n.t('FoodB_requirement_uBiP_YocR' /** 出餐超时率 */),
          icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
        },
      ],
      { show: false },
    ),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        // name: vueI18n.t('FoodB_requirement_puhp_VPIQ' /** 出餐超时订单数 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left],
        },
      }),
      YAxisBuilder({
        // name: vueI18n.t('FoodB_requirement_uBiP_YocR' /** 出餐超时率 */) + '%',
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_requirement_puhp_VPIQ' /** 出餐超时订单数 */),
        type: 'bar',
        barWidth,
        color: '#0D86FF',
        stack: 'test',
        data: deliveryOrdersCntRadio.map(item => item.value ?? '--'),
        silent: true,
        ...BarSelectedBorderBuilder({ barWidth }),
        emphasis: {
          itemStyle: {
            color: '#0D86FF',
          },
        },
      },
      {
        name: vueI18n.t('FoodB_requirement_uBiP_YocR' /** 出餐超时率 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#0C0C0D',
        lineStyle: {
          width: 2,
        },
        emphasis: {
          itemStyle: {
            color: '#0C0C0D',
          },
        },
        data: deliveryOrdersCntRate.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
    legendItems: SERVICE_TIMEOUT_LEGEND_ITEMS(vueI18n.t.bind(vueI18n)),
  }
}

/**
 * 根据柱子在堆叠中的位置返回对应的圆角值
 *
 * @param {boolean} isTop    - 是否为堆叠中最顶部的可见柱段
 * @param {boolean} isBottom - 是否为堆叠中最底部的可见柱段
 * @param {number}  radius   - 圆角半径（默认 4）
 * @returns {number|Array} ECharts borderRadius 值
 *   - 同时为顶部和底部（即只有一段）→ 四角全圆角（number）
 *   - 仅为顶部 → [左上, 右上, 右下, 左下] = [radius, radius, 0, 0]
 *   - 仅为底部 → [0, 0, radius, radius]
 *   - 中间层 → 0（无圆角）
 */
function getStackedBarBorderRadius(isTop, isBottom, radius = 4) {
  if (isTop && isBottom) return radius
  if (isTop) return [radius, radius, 0, 0]
  if (isBottom) return [0, 0, radius, radius]
  return 0
}

/**
 * 为堆叠柱状图的每个数据点动态计算圆角，使堆叠柱的顶部和底部呈现圆角效果
 *
 * 核心问题：
 * ECharts 堆叠柱状图中，每一段柱子的 borderRadius 是静态配置的，
 * 但实际场景中某些段的值可能为 0（不可见），导致"谁是顶部/底部"会动态变化。
 * 本函数逐数据点计算每段柱子的实际位置，赋予正确的圆角。
 *
 * 处理逻辑：
 * 1. 遍历每个系列（series）的每个数据点（dataIndex）
 * 2. 对每个数据点，找出当前所有"可见"的系列索引（值非 0 且不在 hiddenSeriesNames 中）
 * 3. 可见系列中最后一个为"顶部"，第一个为"底部"
 * 4. 根据当前系列是否为顶部/底部，赋予对应的 borderRadius
 * 5. 被隐藏的系列（hiddenSeriesNames）圆角为 0
 *
 * @param {Array} seriesDefs - 系列定义数组，每项包含 { name, type, data, color, stack, barWidth, ... }
 * @param {Object} options - 配置项
 * @param {number} [options.radius=4] - 圆角半径
 * @param {Array}  [options.hiddenSeriesNames=[]] - 被图例隐藏的系列名称列表
 * @returns {Array} 处理后的系列数组，data 中每个数据点带有 itemStyle.borderRadius
 *
 * @example
 * // 输入：4 个堆叠柱系列
 * buildStackedBarSeriesWithCornerRadius([
 *   { name: 'A', data: [10, 0, 5], stack: 's', color: '#086ACC', ... },
 *   { name: 'B', data: [20, 15, 0], stack: 's', color: '#369AFF', ... },
 *   { name: 'C', data: [5, 10, 8], stack: 's', color: '#85C2FF', ... },
 * ])
 * // dataIndex=0: A 底部圆角, C 顶部圆角, B 中间无圆角
 * // dataIndex=1: B 底部圆角, C 顶部圆角 (A 值为 0 不参与)
 * // dataIndex=2: A 底部圆角, C 顶部圆角 (B 值为 0 不参与)
 */
function buildStackedBarSeriesWithCornerRadius(seriesDefs = [], options = {}) {
  const { radius = 4, hiddenSeriesNames = [] } = options

  return seriesDefs.map((seriesDef, seriesIndex) => {
    // 当前系列是否被图例隐藏
    const isCurrentSeriesHidden = hiddenSeriesNames.includes(seriesDef.name)
    const data = (seriesDef.data || []).map((value, dataIndex) => {
      const numericValue = Number(value ?? 0)
      const hasValue = !Number.isNaN(numericValue) && numericValue !== 0

      // 值为 0 或空的数据点不需要圆角处理，直接返回原值
      if (!hasValue) return value

      // 找出当前 dataIndex 下所有"可见且有值"的系列索引
      const visibleSeriesIndexes = seriesDefs
        .map((currentSeries, index) => {
          // 被隐藏的系列排除
          if (hiddenSeriesNames.includes(currentSeries.name)) return -1

          const currentValue = Number(currentSeries.data?.[dataIndex] ?? 0)
          const currentHasValue = !Number.isNaN(currentValue) && currentValue !== 0
          return currentHasValue ? index : -1
        })
        .filter(index => index !== -1)

      // 可见系列中最后一个为堆叠顶部，第一个为堆叠底部
      const topSeriesIndex = visibleSeriesIndexes[visibleSeriesIndexes.length - 1]
      const bottomSeriesIndex = visibleSeriesIndexes[0]

      // 被隐藏的系列不显示圆角，否则根据位置计算
      const borderRadius = isCurrentSeriesHidden
        ? 0
        : getStackedBarBorderRadius(
            seriesIndex === topSeriesIndex,
            seriesIndex === bottomSeriesIndex,
            radius,
          )

      return {
        value,
        itemStyle: {
          borderRadius,
          barBorderRadius: borderRadius, // 兼容旧版 ECharts
        },
      }
    })

    return {
      ...seriesDef,
      data,
      // 高亮时保持原色，避免 ECharts 默认的加亮效果改变颜色
      emphasis: {
        itemStyle: {
          color: seriesDef.color,
        },
      },
    }
  })
}

/**
 * 取消订单原因分类图表（按原因细分）
 * 当某一个对应字段有值才显示对应的原因分类数量，否则不显示
 */
function parseCancelReasonChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  // 一共 16 个取消原因，对应后台字段 + 文案 + 颜色
  const reasonDefs = [
    {
      field: 'dishSoldOut',
      label: vueI18n.t('FoodB_scenario_tTcW_glIK' /** 菜品售罄 */),
      color: '#086ACC',
    },
    {
      field: 'storeClosed',
      label: vueI18n.t('FoodB_scenario_TNIB_LZav' /** 店铺已打烊 */),
      color: '#369AFF',
    },
    {
      field: 'dishNotServeTooBusy',
      label: vueI18n.t('FoodB_scenario_FkIm_wbyt' /** 店铺太忙无法出餐 */),
      color: '#85C2FF',
    },
    {
      field: 'dishNotServeUnexpectedReason',
      label: vueI18n.t('FoodB_scenario_ShEY_kNaS' /** 因停水/停电等意外无法出餐 */),
      color: '#D6EBFF',
    },
    {
      field: 'cDutyCancel',
      label: vueI18n.t('FoodB_scenario_HbKA_WhYt' /** 顾客原因取消 */),
      color: '#189959',
    },
    {
      field: 'riderNeverBeenStore',
      label: vueI18n.t('FoodB_scenario_cPkp_BcjZ' /** 骑手从未到店 */),
      color: '#42C97B',
    },
    {
      field: 'otherQuestion',
      label: vueI18n.t('FoodB_scenario_LpfM_MGER' /** 其他问题 */),
      color: '#87E0AC',
    },
    {
      field: 'noRiderInStore',
      label: vueI18n.t('FoodB_scenario_psNp_kSMI' /** 门店无骑手 */),
      color: '#D5F5E2',
    },
    {
      field: 'menuNeedUpdate',
      label: vueI18n.t('FoodB_scenario_czrv_MZIJ' /** 菜单需要更新 */),
      color: '#9B0FB8',
    },
    {
      field: 'orderInDangerArea',
      label: vueI18n.t('FoodB_scenario_YcnE_hnLK' /** 订单地址位于危险区域 */),
      color: '#CD3BEB',
    },
    {
      field: 'orderBeyondDeliveryRange',
      label: vueI18n.t('FoodB_scenario_iTKN_qRYT' /** 订单超出配送范围 */),
      color: '#E085F2',
    },
    {
      field: 'prankOrder',
      label: vueI18n.t('FoodB_scenario_FmAJ_xFEY' /** 疑似诈骗或恶作剧 */),
      color: '#F4D4FA',
    },
    {
      field: 'questionAboutActivitiesExpenses',
      label: vueI18n.t('FoodB_scenario_Essn_oVjW' /** 对营销活动/费项有疑问 */),
      color: '#CC6E10',
    },
    {
      field: 'orderMissedTimeout',
      label: vueI18n.t('FoodB_scenario_tWmb_Krny' /** 超时未接 */),
      color: '#FF9F40',
    },
    {
      field: 'selfDeliveryTimeout',
      label: vueI18n.t('FoodB_scenario_UTGm_CSqz' /** 自配送履约超时 */),
      color: '#FFC68C',
    },
    {
      field: 'otherBDutyCancelOrder',
      label: vueI18n.t('FoodB_scenario_PuLv_FhUL' /** 其他方发起的B责取消 */),
      color: '#FFECD9',
    },
  ]

  // 过滤出有数据的原因
  const enabledReasons = reasonDefs
    .map(def => {
      const raw = chartData?.[def.field] || []
      return {
        ...def,
        raw,
        data: raw.map(item => item.value),
      }
    })
    .filter(def => {
      // 数组本身为空：不展示该原因
      if (!def.raw || def.raw.length === 0) return false

      // 需要至少有一天的 value 非 0，才认为有“有效数据”
      return def.raw.some(item => {
        const v = Number(item?.value ?? 0)
        return !Number.isNaN(v) && v !== 0
      })
    })

  // 没有任何原因有数据就不展示图表
  if (!enabledReasons.length) {
    return {
      isShow: false,
      grid: { top: 26, left: 16, right: 16, bottom: serviceCancelBottom },
      tooltip: ToolTipBuilder(),
      legend: LegendBuilder([]),
      xAxis: XAxisBuilder({ data: [] }),
      yAxis: [],
      series: [],
      legendItems: [],
    }
  }

  // 计算最大值用于 left padding
  const max = getMaxValue(Object.fromEntries(enabledReasons.map(def => [def.field, def.raw])))

  // x 轴直接用第一个有数据的原因的日期
  const xSource = enabledReasons[0].raw
  const xAxisData = xSource.map(item => item.date)
  const barWidth = getAdaptiveBarWidthByCount(xAxisData.length)

  const left = max ? caculateWidthBy10FontSize(max) + 10 : 16

  const baseBottom = direction === 'vertical' ? serviceCancelBottom : serviceCancelBottomHor

  const roundedCancelReasonSeries = buildStackedBarSeriesWithCornerRadius(
    enabledReasons.map(def => ({
      name: def.label,
      type: 'bar',
      barWidth,
      color: def.color,
      stack: 'serviceCancelReason',
      data: def.data,
    })),
  )

  return {
    isShow: true,
    grid: {
      top: 26,
      left,
      right: 8,
      bottom: baseBottom,
    },
    tooltip: ToolTipBuilder(),
    legend: LegendBuilder(
      enabledReasons.map(def => def.label),
      { show: false },
    ),
    xAxis: XAxisBuilder({
      data: xAxisData.map(item => item.substring(5)),
    }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodOpB_10_Order_volume_WNmq' /** 订单数 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left],
        },
      }),
    ],
    series: [...roundedCancelReasonSeries, WeekendBuilder(xAxisData, dateToWeek)],
    legendItems: enabledReasons.map(def => ({
      name: def.label,
      type: 'bar',
      color: def.color,
    })),
  }
}

// 问题订单
function parseServiceChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  const {
    missingItemOrdersNum = [],
    smallPortionsOrdersNum = [],
    differentThanExpectedOrdersNum = [],
    wrongItemOrdersNum = [],
    imperfectOrderRatio = [],
  } = chartData || {}
  const max = getMaxValue({
    missingItemOrdersNum,
    smallPortionsOrdersNum,
    differentThanExpectedOrdersNum,
    wrongItemOrdersNum,
  })
  const maxRadio = getMaxLengthValue({ imperfectOrderRatio })
  const xAxisData = missingItemOrdersNum.map(item => item.date)
  const barWidth = getAdaptiveBarWidthByCount(xAxisData.length)
  const left = max ? caculateWidthBy10FontSize(max) + 10 : 16
  const right =
    (maxRadio ? caculateWidthBy10FontSize(maxRadio + '%') : caculateWidthBy10FontSize(0, 5)) + 10
  const stackedBarSeries = buildStackedBarSeriesWithCornerRadius([
    {
      name: vueI18n.t('FoodC_revision_Less_meal_pHwq' /** Negatively Rated Orders */),
      type: 'bar',
      barWidth,
      color: '#086ACC',
      stack: 'service',
      data: missingItemOrdersNum.map(item => item.value),
    },
    {
      name: vueI18n.t('FoodC_improve__ovBF' /** Completed Orders */),
      type: 'bar',
      barWidth,
      color: '#369AFF',
      stack: 'service',
      data: smallPortionsOrdersNum.map(item => item.value),
    },
    {
      name: vueI18n.t('FoodC_improve__ByLg' /** Completed Orders */),
      type: 'bar',
      barWidth,
      color: '#85C2FF',
      stack: 'service',
      data: differentThanExpectedOrdersNum.map(item => item.value),
    },
    {
      name: vueI18n.t('CS_Aftersale_Wrong_meal_gNCe' /** Completed Orders */),
      type: 'bar',
      barWidth,
      color: '#D6EBFF',
      stack: 'service',
      data: wrongItemOrdersNum.map(item => item.value),
    },
  ])

  return {
    isShow: [
      missingItemOrdersNum,
      smallPortionsOrdersNum,
      differentThanExpectedOrdersNum,
      wrongItemOrdersNum,
      imperfectOrderRatio,
    ].some(i => !isEmpty(i)),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceQuestionBottom : serviceQuestionBottomHor,
    },
    tooltip: ToolTipBuilder(),
    legend: LegendBuilder(
      [
        vueI18n.t('FoodC_revision_Less_meal_pHwq' /** 少餐反馈 */),
        vueI18n.t('FoodC_improve__ovBF' /** 份量少 */),
        vueI18n.t('FoodC_improve__ByLg' /** 与预期不符 */),
        vueI18n.t('CS_Aftersale_Wrong_meal_gNCe' /** Completed Orders */),
        {
          name: vueI18n.t('Gattaran_opt2_egxV_xfoW' /** 问题订单率 */),
          icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
        },
      ],
      { show: false },
    ),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodOpB_10_Order_volume_WNmq' /** 订单数 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('Gattaran_opt2_egxV_xfoW' /** 差评率% */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      ...stackedBarSeries,
      {
        name: vueI18n.t('Gattaran_opt2_egxV_xfoW' /** 问题订单率 */),
        type: 'line',
        yAxisIndex: 1,
        showSymbol: false,
        color: '#0C0C0D',
        lineStyle: {
          width: 2,
        },
        emphasis: {
          itemStyle: {
            color: '#0C0C0D',
          },
        },
        data: imperfectOrderRatio.map(item => item.value),
        silent: true,
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
    legendItems: SERVICE_QUESTION_LEGEND_ITEMS(vueI18n.t.bind(vueI18n)),
  }
}
